import type {
    InfiniteScrollListFetchPage,
    InfiniteScrollListRemoteFieldPredicateOption,
} from '@/components/ui/infinite-scroll-list.types';
import { loggingApi } from '@/lib/pillarApi';

export const CloudLoggingOptionPageSize: number = 50;

export const fetchCloudLoggingLogIdOptionsPage: InfiniteScrollListFetchPage<
    InfiniteScrollListRemoteFieldPredicateOption,
    string
> = async ({ terms, limit, cursor }) => {
    const response = await loggingApi.listCloudLoggingLogIdOptionsPage({
        terms: terms === undefined ? undefined : [...terms],
        limit,
        cursor,
    });
    return { items: response.options, pagination: response.pagination };
};

export const fetchCloudLoggingResourceTypeOptionsPage: InfiniteScrollListFetchPage<
    InfiniteScrollListRemoteFieldPredicateOption,
    string
> = async ({ terms, limit, cursor }) => {
    const response = await loggingApi.listCloudLoggingResourceTypeOptionsPage({
        terms: terms === undefined ? undefined : [...terms],
        limit,
        cursor,
    });
    return { items: response.options, pagination: response.pagination };
};
